<template>
    <RedesignBaseModal
        :visible="showDialog"
        :title="modalTitle"
        :top="'8vh'"
        append-to-body
        :destroy-on-close="true"
        width="960px"
        wrapper-classes="full-height template-preview-modal"
        @update:visible="onChangeVisible"
        @close="closeModal"
    >
        <WidgetTemplateHelpInfo
            v-if="templateHelpData"
            :template-help="templateHelpData"
        />
    </RedesignBaseModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import RedesignBaseModal from '@/components/RedesignComponents/Modal/RedesignBaseModal.vue'
import { useConfirmBeforeClose } from '@/composables/useConfirmBeforeClose'
import { TemplateHelp } from '@/types/template-help'
import WidgetTemplateHelpInfo from '@/components/RedesignComponents/Widgets/Common/WidgetTemplateHelpInfo.vue'

const emit = defineEmits([ 'close' ])

/* Data */
const { closeWithConfirm } = useConfirmBeforeClose()
const showDialog = ref<boolean>(false)
const templateHelpData = ref<TemplateHelp | undefined>(undefined)

/* Computed */
const modalTitle = computed<string>(() => {
    return templateHelpData.value?.TemplateName || ''
})
/* Watchers

/* Methods */
function onChangeVisible (state: boolean) {
    if (!state) {
        closeModal()
    }
}
function openModal (helpData: TemplateHelp) {
    templateHelpData.value =  { ...helpData }
    showDialog.value = true
}
function forceCloseModal () {
    showDialog.value = false
    emit('close')
    templateHelpData.value = undefined
}

function closeModal () {
    closeWithConfirm(forceCloseModal)
}

/* Exposed */
defineExpose({
    open: openModal,
    close: forceCloseModal
})
</script>
